/*
 web-component-decorator 1.1.1
 @copyright 2020 Edwin Martin
 @license MIT
 */
const t=Symbol();function e(t,e){return n=>{customElements.define(t,n,e)}}function n(e){return function(n,u,r){const o=r.value?"value":"set",s=n.constructor;return s[t]?(s.observedAttributes.push(e),s[t].set(e,r[o])):(s.observedAttributes=[e],s[t]=new Map([[e,r[o]]])),n.attributeChangedCallback=function(e,n,u){s[t].get(e).call(this,u,n)},r}}export{n as attribute,e as define};
//# sourceMappingURL=bundle.min.js.map
